import { validate } from '@/utils/schemaValidatorUtils'
import Configurations from '@/modules/common/common/models/APP/Configuration'
import LifeConfigurationTags from '@/modules/life/common/models/APP/LifeConfigurationTags'
import LifeConfigurationsHiringAges from './LifeConfigurationHiringAges'
import type { OptionsValuesInterface } from '@/modules/core/models/types'
import schema from '@/modules/life/common/schemas/APP/LifeConfigurationsSchema'
import LifeConfigurationCapitalOption from './LifeConfigurationCapitalOption'
import LifeReevaluationOption from './LifeReevaluationOption'
import LifeConfigurationInsuranceTypes from './LifeConfigurationInsuranceTypes'

export default class LifeConfigurations extends Configurations<LifeConfigurationsHiringAges> {
  insuranceTypes!: LifeConfigurationInsuranceTypes
  tags!: LifeConfigurationTags
  capitalOptions!: LifeConfigurationCapitalOption[]
  reevaluationOptions!: LifeReevaluationOption[]

  constructor(data?: any) {
    validate(schema, data)

    super(data)

    if (data?.insuranceTypes) {
      this.insuranceTypes = new LifeConfigurationInsuranceTypes(data.insuranceTypes)
    }

    if (data?.hiringMaxAges) {
      this.hiringMaxAges = new LifeConfigurationsHiringAges(data.hiringMaxAges)
    }

    if (data?.tags) {
      this.tags = new LifeConfigurationTags(data.tags)
    }

    if (data?.capitalOptions) {
      this.capitalOptions = data.capitalOptions.map(
        (c: any) => new LifeConfigurationCapitalOption(c)
      )
    }

    if (data?.reevaluationOptions) {
      this.reevaluationOptions = data.reevaluationOptions.map(
        (r: any) => new LifeReevaluationOption(r)
      )
    }
  }

  getInsuranceTypesOptions(forWhom: string): OptionsValuesInterface[] {
    const options = Object.values(this.insuranceTypes)
    return options.map(({ textMe, textNotMe, id, disabled }) => ({
      label: forWhom === 'me' ? textMe : textNotMe,
      value: id,
      disabled: !!disabled
    }))
  }

  setReevaluationOptions(options: LifeReevaluationOption[]) {
    this.reevaluationOptions = options.map((o) => {
      const innerOption = {
        ...o,
        description: o.value === '0.0' ? 'No actualizar' : `${Math.floor(Number(o.value))}%`
      }
      return new LifeReevaluationOption(innerOption)
    })
  }

  get defaultInsuranceType(): string | null {
    return this.getDefaultValue(this.insuranceTypes)
  }
}
